import { render, staticRenderFns } from "./campusDialog.vue?vue&type=template&id=5933ea44&scoped=true&"
import script from "./campusDialog.vue?vue&type=script&lang=js&"
export * from "./campusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5933ea44",
  null
  
)

export default component.exports